module.exports = __webpack_public_path__ + "static/media/boundary_icon.aa89e1d0.svg";